/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {SET_COMP_CODE} from "../_actions/comp.code.actions";
export const INITIAL_STATE = {
    code:"",
};

export function compCodeReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_COMP_CODE: {
            const newObj = {...state};
            action.payload.map(opsAdminCode => {
                newObj['code']= opsAdminCode.code; 
            });
            return newObj;
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/comp.code.reducer.js